// Angular
import { Injectable, OnDestroy } from '@angular/core';

// Libraries
import { OnboardingItem, OnboardingService } from '@rosen-group/ngx-onboarding';

// Services
import { AppCleanup } from '../models';
import { OnboardingKey } from '../types/types';
import { OnboardingSelectorService } from './onboarding.selector.service';

@Injectable({
  providedIn: 'root',
})
export class UserProfileService extends AppCleanup implements OnDestroy {
  private readonly userProfileMenuKey: string = 'user-profile';
  private unregisterOnboarding: Function;
  private onboardingSelectors: OnboardingItem[];

  constructor(
    private onboardingSelectorService: OnboardingSelectorService,
    private onboardingService: OnboardingService
  ) {
    super();
  }

  ngOnDestroy() {
    this.unregister();
  }

  initializeOnboarding(onboardingKey: OnboardingKey) {
    this.unregister();

    // Open user profile menu.
    if (onboardingKey === this.userProfileMenuKey) {
      this.openUserProfileDropdown();
    }

    // Initialize onboarding items.
    this.initializeOnboardingItems(onboardingKey);

    // Close user profile menu.
    if (onboardingKey !== this.userProfileMenuKey) {
      this.closeUserProfileDropdown();
    }
  }

  private initializeOnboardingItems(onboardingKey: OnboardingKey) {
    this.onboardingSelectors = [];
    this.onboardingService.clearSeenSelectors();
    this.onboardingSelectors = this.onboardingSelectorService.getOnboardingItems(onboardingKey);
    this.unregisterOnboarding = this.onboardingService.register(this.onboardingSelectors);
    this.onboardingService.enable();
  }

  private openUserProfileDropdown() {
    // TODO Fix this
  }

  private closeUserProfileDropdown() {
    // TODO Fix this
  }

  private unregister() {
    if (this.unregisterOnboarding) {
      this.unregisterOnboarding();
    }
  }
}
